
import React, { useState, useEffect } from "react";

const DefaultEins = (props) => {
  //const [einsData, EinsListData] = useState([]);
  const [selectedEin, setSelectedEin] = useState("");
  const [EinList, setEinList] = useState([]);

  const { defaultEin, companyId, einList } = props;

  useEffect(() => {
    setSelectedEin(defaultEin);
    setEinList(einList);
  }, [einList]);


  const handleChange = (e) => {
    setSelectedEin(e.target.value)
  }

  const save = async () => {
    const payload = {
      defaultEIN: selectedEin,
      clientID: companyId
    }
    await props.onSave(payload);
  }

  return (

    <div className="reportId df align-items-center justify-content-between">
      <div className="reportIdField">
        {/* <div className="setDefaultLabel">
        Set as default 
      </div> */}
        <select className="selectBox" style={{ marginRight: '15px' }} selected={selectedEin?._id} onChange={(e) => handleChange(e)}>
          {EinList.map((item, index) => (<option key={index} value={item._id}>{item.companyEIN}</option>))}
        </select>
      </div>
      <div className="reportIdField">
        <button className="btn reportBtn" onClick={save}>Save</button>
      </div>
    </div>
  );
};

export default DefaultEins;
